
<ngx-spinner
    bdColor = "rgba(51,51,51,0.8)" 
    size = "medium" 
    color = "#fff"
    type = "timer" 
    [fullScreen] = "true">
</ngx-spinner>
